<template>
  <v-card class="elevation-0" flat>
    <v-card-text>
      <v-form>
        <v-text-field
          append-icon="person"
          label="Email"
          type="text"
          outline
          disabled
          v-model="this.user.email"
          v-on:keyup.13="next"
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn depressed small text color="indigo" :to="{ name: 'logout' }"
        >Não sou eu</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn block color="primary" @click="next" :loading="logging"
        >Avançar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {},
  data: () => ({}),
  computed: mapGetters({
    user: "authUser",
    authenticated: "authCheck",
  }),
  methods: {
    mounted() {},
    next() {
      // console.log(this.user)
      this.$emit("logged", this.user);
    },
  },
};
</script>
